import { get, getIdFromUrl } from './api';

const BASE_URL = '/people'


export const getPersonId = async () => {
  const { results } = await get(BASE_URL);
  
  return results.map(person => {
    return {
       id: getIdFromUrl(person.url),
    };
  })
}

export const getAll = ({ page = 1, search = 'e' }) => {
  const urlParams = new URLSearchParams();

  urlParams.set('page', page);
  urlParams.set('search', search);

  return get(`/people?${urlParams.toString()}`);
};

// export const getOne = (id)  => (
//    get(`${BASE_URL}/${id})
// )